import React from "react";
import intl from "react-intl-universal";

import {useAppState} from "@stores/AppStateContext";

import {TaskReportViewOnlyProps} from "../modal-names";

import {ModalBase} from "../components/ModalBase";
import {formatDayWithShortMonth} from "../../../../utils/date";
import {TaskReportComplete} from "./TaskReportComplete";
import {Button} from "../../../components/Button";
import {InTextLabel} from "../../../components/InTextLabel";
import {CantCompleteTask} from "./CantCompleteTask";
import {FlagIcon} from "../../../components/icons/FlagIcon";
import {TaskReportMissed} from "./TaskReportMissed";
import {CheckBoxIcon} from "../../../components/icons/CheckBoxIcon";

import {screenSizeProvider} from "@stores/ScreenSizeProvider";

import "../TaskReportEdit/TaskReportEdit.css";

export const TaskReportViewOnly = (
    {
        calendarTable,
        reportForDay
    }: TaskReportViewOnlyProps
) => {

    const appState = useAppState();
    const handleClose = () => {
        appState.setModal(null);
    };

    const isMobile = screenSizeProvider.view !== 'desktop';
    const renderContent = () => {
        switch (reportForDay.status) {
            case "completed":
                return (
                    <TaskReportComplete
                        calendarTable={calendarTable}
                        report={reportForDay}
                    />
                );
            case "incomplete":
                return (
                    <CantCompleteTask
                        report={reportForDay}
                        calendarTable={calendarTable}
                    />
                );
            case "skipped":
                return (
                    <TaskReportMissed
                        report={reportForDay}
                        calendarTable={calendarTable}
                    />
                )
            default:
                return null;
        }
    };

    return (
        <ModalBase
            header={
                <div className={"TaskReportViewOnlyModal__header"}>
                    <InTextLabel
                        className="TaskReportViewOnlyModal__label"
                        text={intl.get("TaskReportViewOnlyModal.label").d("View only")}
                        type={"neutral"}
                        size={"sm"}
                    />
                    {reportForDay.status === "incomplete"
                        ? <InTextLabel
                            size="sm"
                            Icon={FlagIcon}
                            text={intl.get('taskReportEdit.cant-complete-task.label').d("Can't Complete Task")}
                            type="danger"
                            className="TaskReportViewOnlyModal__label"
                        /> : null
                    }
                    {reportForDay.status === "skipped"
                        ? <InTextLabel
                            size="sm"
                            Icon={CheckBoxIcon}
                            text={intl.get('taskReportEdit.missedTask.label').d("Missed")}
                            type="danger"
                            className="TaskReportViewOnlyModal__label"
                        /> : null
                    }
                    <div className="body-medium TaskReportEdit__headerDate">
                        {formatDayWithShortMonth(reportForDay.completedAt)}
                    </div>
                </div>
            }
            open={true}
            onClose={handleClose}
            minWidth={isMobile ? 400 : 640}
            maxWidth={640}
        >
            {renderContent()}
            <Button
                className={"TaskReportViewOnlyModal__button"}
                text={intl.get("common.close").d("Close")}
                type={"primary"}
                style={'solid'}
                onClick={handleClose}
            />
        </ModalBase>
    );
};
